module.exports = __webpack_public_path__ + "img/eIDLINK.e09d0ea1.png";